import React, { useEffect, useState } from 'react';

const DISPLAY_DURATION = 5000; // ms per simcha
const FADE_DURATION = 500;     // ms fade transition

const Spotlight = ({ initialData = { simchas: [] }, title = 'שמחות בקהילה', showTitle = true, bgColor }) => {
  const [now, setNow] = useState(() => new Date());
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 60_000);
    return () => clearInterval(id);
  }, []);

  const simchas = (initialData.simchas || []).filter(
    s => !s.expiryDate || new Date(s.expiryDate) > now
  );

  useEffect(() => {
    if (simchas.length <= 1) return;
    const interval = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setCurrentIndex(i => (i + 1) % simchas.length);
        setVisible(true);
      }, FADE_DURATION);
    }, DISPLAY_DURATION);
    return () => clearInterval(interval);
  }, [simchas.length]);

  // Reset index if simchas change and index is out of range
  useEffect(() => {
    if (currentIndex >= simchas.length && simchas.length > 0) {
      setCurrentIndex(0);
    }
  }, [simchas.length, currentIndex]);

  const getLabel = (type, customType) => {
    const map = {
      birth_boy: 'הולדת הבן', birth_girl: 'הולדת הבת',
      grandchild_boy: 'הולדת נכד', grandchild_girl: 'הולדת נכדה',
      engagement_boy: 'אירוסי הבן', engagement_girl: 'אירוסי הבת',
      wedding_boy: 'חתונת הבן', wedding_girl: 'חתונת הבת',
      bar_mitzvah: 'בר מצווה', other: customType || 'שמחה',
    };
    return map[type] || customType || 'שמחה';
  };

  const boldLabel = (type, label, boldWords) => {
    if (type !== 'other') return <strong>{label}</strong>;
    if (!boldWords?.length) return label;
    return label.split(/(\s+)/).map((w, i) =>
      boldWords.includes(w.trim()) && w.trim() ? <strong key={i}>{w}</strong> : w
    );
  };

  const current = simchas[currentIndex];

  return (
    <div style={{
      padding: '12px',
      direction: 'rtl',
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
      backgroundColor: bgColor || '#f8f7f5',
      fontSize: 'inherit',
    }}>
      {showTitle && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          borderBottom: '1px solid #e0dcd2',
          paddingBottom: '8px',
          marginBottom: '10px',
        }}>
          <span style={{ color: '#8a6d08', fontSize: '0.75em' }}>✦</span>
          <h3 style={{ margin: 0, color: '#1e3a5f', fontWeight: 700, fontSize: '0.875em' }}>
            {title}
          </h3>
          {simchas.length > 1 && (
            <span style={{ marginRight: 'auto', color: '#94a3b8', fontSize: '0.6em' }}>
              {currentIndex + 1} / {simchas.length}
            </span>
          )}
        </div>
      )}

      <div style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        {simchas.length === 0 ? (
          <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.85em' }}>
            אין שמחות כרגע
          </div>
        ) : current ? (
          <div style={{
            textAlign: 'center',
            opacity: visible ? 1 : 0,
            transition: `opacity ${FADE_DURATION}ms ease`,
            padding: '8px',
            width: '100%',
          }}>
            {/* Ornament */}
            <div style={{ color: '#c8a84b', fontSize: '0.75em', letterSpacing: '0.3em', marginBottom: '10px' }}>
              ✦&nbsp;&nbsp;✦&nbsp;&nbsp;✦
            </div>

            {/* Celebration type */}
            <div style={{
              color: '#8a6d08',
              fontSize: '0.72em',
              letterSpacing: '0.12em',
              fontWeight: 600,
              marginBottom: '6px',
            }}>
              {boldLabel(current.type, getLabel(current.type, current.customType), current.customTypeBold)}
              {current.celebrant ? ` · ${current.celebrant}` : ''}
            </div>

            {/* Family name - large */}
            <div style={{
              color: '#1e3a5f',
              fontWeight: 800,
              fontSize: '1.25em',
              lineHeight: 1.2,
              marginBottom: '6px',
            }}>
              {current.name}
            </div>

            {/* Bottom ornament line */}
            <div style={{
              margin: '0 auto',
              width: '50%',
              height: '1px',
              background: 'linear-gradient(to left, transparent, #c8a84b 30%, #c8a84b 70%, transparent)',
            }} />

            {current.additionalText && (
              <div style={{ color: '#64748b', fontSize: '0.68em', fontStyle: 'italic', marginTop: '8px' }}>
                {current.additionalText}
              </div>
            )}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Spotlight;
